import { useTranslation } from 'next-i18next';
import { AboutComponent } from '@/widgets/AboutComponent';
import { JsonLdDecorator, MetaDecorator } from '@/shared/utils';
import { FAQ } from '@/widgets/FAQ';
import { RedirectToAppButton } from '@/widgets/RedirectToAppButton';
import { getListItemsJsonLd } from '../lib/listItemsJsonLd';
import { getQuestions } from '../lib/questions';
import AutomationBenefits from './AutomationBenefits';
import AutomationReviews from './AutomationReviews';
import GetStartedBlock from './GetStartedBlock';
import HowItWorkBlock from './HowItWorkBlock';
import NewCustomerForm from './NewCustomerForm';
import ReviewsRequestsBlock from './ReviewsRequestsBlock';
import VideoBlock from './VideoBlock';
import WhoIsThisForSection from './WhoIsThisForSection';
import main1 from '/public/main-page/main-1.webp';
import main2 from '/public/main-page/main-2.png';

const MainPage = () => {
  const { t } = useTranslation();
  const questions = getQuestions(t);
  const listItemsJsonLd = getListItemsJsonLd(t);

  return (
    <>
      <MetaDecorator
        description='meta.main.description'
        keywords='meta.main.keywords'
        title='meta.main.title'
      />
      <JsonLdDecorator
        faqList={questions}
        listItems={listItemsJsonLd}
      />
      <AboutComponent
        button={
          <RedirectToAppButton
            buttonText={t('mainPage.mainBlock.buttonText')}
            dataLayer={{ data: { redirected_from: 'main_page_main_block' } }}
            pageName='signup'
            size='md'
          />
        }
        containerProps={{ gap: '20' }}
        description={t('mainPage.mainBlock.subheading')}
        heading={t('mainPage.mainBlock.heading')}
        headingAs='h1'
        headingProps={{
          whiteSpace: 'pre-wrap',
        }}
        image={main1}
        imageAlt={t('mainPage.mainBlock.heading')}
        imageProps={{ isEager: true }}
      />
      <HowItWorkBlock />
      <AboutComponent
        containerProps={{ gap: '20' }}
        description={t('mainPage.whyMatters.description')}
        heading={t('mainPage.whyMatters.heading')}
        image={main2}
        imageAlt={t('mainPage.whyMatters.heading')}
        isOdd
      />
      <AutomationBenefits />
      <ReviewsRequestsBlock />
      <WhoIsThisForSection />
      <AutomationReviews />
      <VideoBlock />
      <NewCustomerForm />
      <FAQ questions={questions} />
      <GetStartedBlock />
    </>
  );
};

export default MainPage;
